// Seton Hall's undergraduate majors (#2743). Read on 2026-10-01 from the
// official Undergraduate Catalogue 2026-2027 (catalog.shu.edu): every
// program page linked from each college or school's catalogue page and its
// department pages, with the degree in the page title ("Biology Major (B.S.)"
// -> Biology, B.S.). Left out: minors, certificates, combined bachelor's and
// graduate programs (B.S./M.S., B.A./J.D., 3+2, 4+1, five-year dual degrees),
// the second-degree Accelerated BSN, honors tracks, and the "Secondary Major"
// in languages (taken with a primary major). Majors listed once per
// concentration (Social and Behavioral Sciences, Art, Design and Interactive
// Multimedia, Visual and Sound Media) are folded into one line with the
// concentrations in a note; the catalogue gives no degree for Social and
// Behavioral Sciences, so it is null. The page titled "Art History Major
// (B.A.)" sits at a URL named communication-ba; the title is used. The
// Division of Continuing Education and Professional Studies lists no
// bachelor's program page. The KB's majors list was the starting point; the
// catalogue wins.
const majors = {
    "slug": "seton-hall-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Seton Hall's official 2026-2027 Undergraduate Catalogue, grouped by the college or school that offers it, with the degree it leads to. Combined bachelor's and graduate programs, minors and certificates are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Seton Hall Undergraduate Catalogue 2026-2027, College of Arts and Sciences",
                "url": "https://catalog.shu.edu/undergraduate/college-arts-sciences/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Catholic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry (Non-ACS)",
                    "degree": "B.S."
                },
                {
                    "name": "Classical Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Cognitive and Behavioral Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Creative Writing",
                    "degree": "B.A."
                },
                {
                    "name": "Criminal Justice",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Financial Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Italian",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American and Latino/Latina Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Liberal Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Modern Languages",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy and Law",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Religion",
                    "degree": "B.A."
                },
                {
                    "name": "Social Work",
                    "degree": "B.A."
                },
                {
                    "name": "Social and Behavioral Sciences",
                    "degree": null,
                    "note": "Concentrations: Allied Health; Culture and Society; Policy, Justice, and Administration."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Human Development, Culture, and Media",
            "source": {
                "label": "Seton Hall Undergraduate Catalogue 2026-2027, College of Human Development, Culture, and Media",
                "url": "https://catalog.shu.edu/undergraduate/college-of-human-development-culture-and-media/"
            },
            "majors": [
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Art, Design and Interactive Multimedia",
                    "degree": "B.A.",
                    "note": "Concentrations: Fine and Digital Arts, Graphic Design and Advertising, Interactive Design and Multimedia."
                },
                {
                    "name": "Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Elementary and Special Education",
                    "degree": "B.S.E."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Public Relations",
                    "degree": "B.A."
                },
                {
                    "name": "Secondary Education",
                    "degree": "B.S.E."
                },
                {
                    "name": "Secondary Education and Special Education",
                    "degree": "B.S.E."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Visual and Sound Media",
                    "degree": "B.A.",
                    "note": "Concentrations: Film Production, Media Studies, Sound Production and Engineering, Sports Media, Television Production."
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "Seton Hall Undergraduate Catalogue 2026-2027, College of Nursing",
                "url": "https://catalog.shu.edu/undergraduate/college-nursing/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "Immaculate Conception Seminary School of Theology",
            "source": {
                "label": "Seton Hall Undergraduate Catalogue 2026-2027, Immaculate Conception Seminary School of Theology",
                "url": "https://catalog.shu.edu/undergraduate/immaculate-conception-seminary-school-theology/"
            },
            "majors": [
                {
                    "name": "Catholic Theology",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Diplomacy and International Relations",
            "source": {
                "label": "Seton Hall Undergraduate Catalogue 2026-2027, School of Diplomacy and International Relations",
                "url": "https://catalog.shu.edu/undergraduate/school-diplomacy-international-relations/"
            },
            "majors": [
                {
                    "name": "Diplomacy and International Relations",
                    "degree": "B.S."
                },
                {
                    "name": "Diplomacy and Law",
                    "degree": "B.S."
                },
                {
                    "name": "International Economics and International Relations",
                    "degree": "B.S."
                },
                {
                    "name": "International Quantitative Economics and International Relations",
                    "degree": "B.S."
                },
                {
                    "name": "International and Homeland Security",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Health and Medical Sciences",
            "source": {
                "label": "Seton Hall Undergraduate Catalogue 2026-2027, School of Health and Medical Sciences",
                "url": "https://catalog.shu.edu/undergraduate/school-health-medical-sciences/"
            },
            "majors": [
                {
                    "name": "Interprofessional Health Sciences",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Stillman School of Business",
            "source": {
                "label": "Seton Hall Undergraduate Catalogue 2026-2027, Stillman School of Business",
                "url": "https://catalog.shu.edu/undergraduate/stillman-school-business/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S.B."
                },
                {
                    "name": "Arts and Science",
                    "degree": "B.A.B.A."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.A."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.S.B."
                },
                {
                    "name": "Business Analytics",
                    "degree": "B.S.B."
                },
                {
                    "name": "Diplomacy and International Relations",
                    "degree": "B.A.B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S.B."
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "B.S.B."
                },
                {
                    "name": "Finance",
                    "degree": "B.S.B."
                },
                {
                    "name": "Finance and Technology",
                    "degree": "B.S.B."
                },
                {
                    "name": "Forensic Accounting",
                    "degree": "B.S.B."
                },
                {
                    "name": "General Studies",
                    "degree": "B.A.B.A."
                },
                {
                    "name": "Global Supply Chain Management",
                    "degree": "B.S.B."
                },
                {
                    "name": "Information Technology Management",
                    "degree": "B.S.B."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A.B.A."
                },
                {
                    "name": "Management",
                    "degree": "B.S.B."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S.B."
                },
                {
                    "name": "Mathematical Finance",
                    "degree": "B.S.B."
                },
                {
                    "name": "Quantitative Economics and Econometrics",
                    "degree": "B.S.B."
                },
                {
                    "name": "Sport Management",
                    "degree": "B.S.B."
                },
                {
                    "name": "Wealth Management",
                    "degree": "B.S.B."
                }
            ]
        }
    ]
};

export default majors;
